import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import './WhoForPage.scss';

export class WhoForPage extends Component {
  render() {
    this.backNext = "";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "icon-button-order",
        inputs: [
          {
            type: 'icon-button',
            id: "for-me",
            className: "btn--icon btn--myself",
            icon: "me",
            value: 'Me',
            onClick: () => {
              this.props.webAppointmentSetForMe(true);
              this.props.history.push(nextPage(null, { forMe: true }));
            }
          },
          {
            type: 'icon-button',
            id: "for-someone-else",
            className: "btn--icon btn--someone-else",
            icon: "someone-else",
            value: 'Someone else',
            onClick: () => {
              this.props.webAppointmentSetForMe(false);
              this.props.history.push(nextPage(null, { forMe: false }));
            }
          },
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: 'button',
            id: "back",
            className: "btn--secondary",
            value: 'Back',
            onClick: () => {
              this.props.history.goBack();
            }
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>Who is this request for?</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

WhoForPage.propTypes = {
  webAppointmentSetForMe: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetForMe: (value) => dispatch(webAppointmentActions.webAppointmentSetForMe(value)),
  };
};

// connects component to redux, and passes along the router
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WhoForPage));
